import type { ArticleCard } from "#lib/types/shared.js";

type opt = {
	sveltekitServerFetch?: typeof fetch;
	last?: number;
	category?: "Nyheter" | "Sparetips" | "Fremhevet";
};

// NOTE: `last` can not be sent to endpoint since endpoint is SSG including possibly unpublished articles
export const fetchArticles = async (opt: opt): Promise<ArticleCard[]> => {
	const { sveltekitServerFetch, last } = opt;
	const category = opt?.category || "";
	const apiUrl = !category
		? `/api/privat/artikler`
		: `/api/privat/artikler/${category.toLowerCase()}`;

	const res = sveltekitServerFetch ? await sveltekitServerFetch(apiUrl) : await fetch(apiUrl);

	// Hide articles with a future publishedAt or a past unpublishAt
	if (res.ok) {
		const data: { articles: ArticleCard[] } = await res.json();
		const articles: ArticleCard[] = data.articles;

		const items = articles.filter((article) => {
			const now = new Date();
			const isPublished = new Date(article.publishedAt) <= now;
			const notExpired = !article.unpublishAt || new Date(article.unpublishAt) > now;
			return isPublished && notExpired;
		});

		return last ? items.slice(0, last) : items;
	}

	return [];
};
